import { api } from "api";

/**
 * Read a city's order auto-advance config. Reuses the existing GET /city/:id
 * (returns the full city row); we only surface the two auto-advance fields.
 */
export const getCityAutoAdvance = async (cityId) => {
    const response = await api.get(`api/city/${cityId}`);
    return {
        enabled: !!response.data?.auto_advance_preparing_enabled,
        minutes: response.data?.auto_advance_preparing_minutes ?? 3,
    };
};

/**
 * Toggle a city's order auto-advance. Hits the guarded endpoint
 * PATCH /api/city/:id/order-auto-advance (super_admin any city; scoped admin
 * with manage_orders limited to their own city).
 */
export const updateCityAutoAdvance = async ({ cityId, enabled, minutes }) => {
    const response = await api.patch(`api/city/${cityId}/order-auto-advance`, {
        enabled,
        minutes,
    });
    return response.data;
};
